import { useEffect, Fragment } from 'react'
import { Trans, t } from '@lingui/macro'
import { useRouter } from 'next/router'
import Head from 'next/head'
import { useTranslations } from 'providers/TranslationsProvider'
import H1 from 'components/ui/H1'
import H2 from 'components/ui/H2'
import Header from 'components/ui/Header'
import TeamMemberCard from 'components/TeamMemberCard'
import LeadingParagraph from 'components/ui/LeadingParagraph'

const TeamIndex = ({ items, groups }) => {
  const { locale } = useRouter()
  const { init, headLinks } = useTranslations()

  useEffect(() => {
    init()
  }, [])

  return (
    <div>
      <div className="container">
        <Head>
          <title key="title">
            {`${t`Team & Governance`} - ${process.env.NEXT_PUBLIC_SITE_TITLE}`}
          </title>
          <meta
            property="og:title"
            content={t`Team & Governance`}
            key="og:title"
          />
          <link
            rel="canonical"
            href={`${process.env.NEXT_PUBLIC_DOMAIN}${
              locale == 'en' ? `` : `/${locale}`
            }/team`}
            key="canonical"
          />
          <meta
            property="og:url"
            content={`${process.env.NEXT_PUBLIC_DOMAIN}${
              locale == 'en' ? `` : `/${locale}`
            }/team`}
            key="og:url"
          />
          {headLinks()}
        </Head>
        <Header>
          <H1>
            <Trans>Team & Governance</Trans>
          </H1>
        </Header>
        <LeadingParagraph>
          <Trans>
            IDPC&apos;s governance model comprises three core elements: the{' '}
            <a href="#idpc-board-of-directors">
              <strong>Board of Directors</strong>
            </a>
            , the{' '}
            <a href="#members-advisory-council">
              <strong>Members&apos; Advisory Council</strong>
            </a>{' '}
            and the{' '}
            <a href="#idpc-secretariat">
              <strong>IDPC Secretariat&apos;s Team</strong>
            </a>
            .
          </Trans>
        </LeadingParagraph>
        {groups?.length && (
          <div>
            {groups.map((group) => (
              <div
                className="my-10 lg:my-20"
                key={group._id}
                id={group.name.en.toLowerCase().replace(/[^a-z0-9]+/g, '-')}
              >
                <H2>{group.name[locale]}</H2>
                <div className="mb-4 text-primary-300 lg:mb-10 lg:text-xl">
                  {group.description[locale]}
                </div>
                <ul className="grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-10 lg:grid-cols-4">
                  {items
                    .filter(
                      (item) =>
                        item.teamGroup.some(
                          (tgroup) => tgroup._ref === group._id
                        )
                      // item.teamGroup && item.teamGroup[0]?._ref === group._id
                    )
                    .map((item) => (
                      <li key={item._id}>
                        <TeamMemberCard item={item} />
                      </li>
                    ))}
                </ul>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
export default TeamIndex
